import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=5e198bf4&scoped=true"
import script from "./temperature.vue?vue&type=script&lang=js"
export * from "./temperature.vue?vue&type=script&lang=js"
import style0 from "./temperature.vue?vue&type=style&index=0&id=5e198bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e198bf4",
  null
  
)

export default component.exports